/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Source_DescInputs */

const en_fc_dl_source_desc = /** @type {(inputs: Fc_Dl_Source_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs Rust 1.95 or newer (install with rustup). The app starts with a demo project.`)
};

/**
* | output |
* | --- |
* | "Needs Rust 1.95 or newer (install with rustup). The app starts with a demo project." |
*
* @param {Fc_Dl_Source_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_source_desc = /** @type {((inputs?: Fc_Dl_Source_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Source_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_source_desc(inputs)
});
export { fc_dl_source_desc as "fc.dl.source.desc" }